import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';
import ClearIcon from '@mui/icons-material/Clear';
import LaunchIcon from '@mui/icons-material/Launch';
import Breadcrumb from '../../../component/Breadcrumb';
import { eventTypeOptions, options, refOptions } from '../../../constants';
import { Box, Button, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { fetchAutoCompleteSheetData, getEventsMasterMappingData } from '../../../api/mappingApi';
import FormTextField from '../../../component/EditRowForm';
import FormNumberField from '../../../component/NumberInput';
import EditMappingEventModal from './EditMappingEventModal';
import swal from 'sweetalert';
import Loader from '../../../component/Loader/Loader';

const EditMappingEvent = () => {

    const location  = useLocation();
    const inputRef  = useRef(null);
    const [open, setOpen]                            = useState(false);
    const [eventMappingData,setEventMappingData]     = useState([]);
    const [eventEditableKeys,setEventEditableKeys]   = useState({});
    const [modalEditField, setModalEditField]        = useState({});
    const [sheetFilter, setSheetFilter]              = useState('');
    const [searchForm, setSearchForm]                = useState(false);
    const [searchValue, setSearchValue]              = useState('');
    const [showChangeBy,setShowChangeBy]             = useState(false);
    const [showLoader, setShowLoader]                = useState(false);
    const [modalUpdatedValues, setModalUpdatedValues]   = useState({});
    const [sheetMappingData, setSheetMappingData]       = useState([]);
    const [autoCompleteLoading, setAutoCompleteLoading] = useState(false);
    const [fields,setFields] = useState({
        ETxt:  null,
        FTxt:  null,
        STxt:  null,
        GTxt:  null,
        ITxt:  null,
        DTxt:  null,
        NTxt:  null,
        PTxt:  null,
        PeTxt: null,
        TTxt:  null,
        CTxt:  null,
        RTxt:  null,
        SigAddr: null,
        Spn: null,
        Fmi: null,
        Div: null,
        RDef: null,
        EType: null,
        AR: null,
        TOn: null,
        LOn: null,
        LOS: null,
        TOff: null,
        ECNTRSig: null,
        ECNTRDel: null,
        ARTFactor: null,
        IB1: null,
        IBT1: null,
        IB2: null,
        IBT2: null,
        Sig0: null,
        Sig1: null,
        Sig2: null,
        Sig3: null,
        Sig4: null,
        Sig5: null,
        Sig6: null,
        Sig7: null,
        En: null,
        HE: null,
        RSA3B: null,
        Family: null,
        TTID: null
    });

    useEffect(() => {
        if(!open){
            setSearchForm(false);
            setSheetFilter('');
            setShowChangeBy(false);
            setSearchValue('');
        }        
    },[open])

    const handleClickOpen = (fieldName,value,label) => {
        if(fieldName === 'SigAddr' || fieldName === 'Sig0' || fieldName === 'Sig1' || fieldName === 'Sig2' || fieldName === 'Sig3' || fieldName === 'Sig4' || fieldName === 'Sig5' || fieldName === 'Sig6' || fieldName === 'Sig7' || fieldName === 'IB1' || fieldName === 'IB2'){
            setShowChangeBy('1');
        }
        setModalEditField({
            fieldName : fieldName,
            value : value,
            label: label
        })
        setOpen(true);
    };
  
    const handleClose = () => {
        setOpen(false);
    };
  
    const handleSheetFilter = (e) => {
        setSearchForm(true);
        setSheetFilter(e.target.value)
    }

    useEffect(() => {
        if(searchValue === ''){
            setSheetMappingData([]);
            return;
        }
        let active;
        if(sheetFilter){
            active = true;
            ( async () => {
                    setAutoCompleteLoading(true);
                    const data = await fetchAutoCompleteSheetData('',sheetFilter,searchValue);
                    if(active){
                        setSheetMappingData(data);
                        setAutoCompleteLoading(false);
                    }
                }
            )();
        }
        return () => {
            active = false;
        }
    },[sheetFilter,searchValue])

    const handleSearchValueAutoComplete = (value) => {
        setSearchValue(value)
    }

    useEffect(()=> {
        if(location.state?.eventId !== '' && location.state?.eventId !== undefined){
            let existingEvents  = JSON.parse(localStorage.getItem('Events'));
            const selectedEvent = existingEvents?.find(event =>  event.EId === location.state?.eventId );
            setFields(prevState => ({
                ...prevState,
                ...selectedEvent
            }));
            setEventEditableKeys(selectedEvent)
            getMasterMappingData();
        }
    },[location.state?.eventId]);

    const getMasterMappingData = async () => {
        setShowLoader(true);
        const masterMappingData = await getEventsMasterMappingData(location.state?.eventId);
        setShowLoader(false);
        setEventMappingData(masterMappingData)
    }


    const changeHandler = (name,value) => {
        //if(value !== null &&  value !== undefined && fields[name] !== value && eventMappingData[name] !== value)  {
        if(value !== null &&  value !== undefined)  {
            let finalVal;
            if(name === 'RSA3B' || name === 'TTID' || name === 'HE' || name === 'Spn' || name === 'Fmi' || name === 'AR' ||  name === 'En'){
                finalVal = value !== '' && value !== null && value !== undefined ? parseInt(value, 10) : '';
            } else if(name === 'Div' || name === 'TOn' || name === 'LOn' || name === 'LOS' ||  name === 'TOff' || name === 'ECNTRSig' || name === 'ECNTRDel' || name === 'ARTFactor' || name === 'IB1' || name === 'IB2' || name === 'IBT1' || name === 'IBT2') {
                // const result = decimalValidation(name,value);
                // if(result){
                //     swal("Oops!", "Please use Float value!", "error");
                // }
                // //finalVal = value ? parseFloat(value) : '';
                // if(value % 1 === 0){
                //     value = Number(value) === 0 ? 0.000001 : parseFloat(value) + 0.000001;
                // }
                //finalVal = value ? parseFloat(value) : '';
                finalVal = value !== '' && value !== null && value !== undefined ? Number(value) : '';
            }  else {
                finalVal = value;
            }
            setFields((prevState) => ({...prevState, [name]: finalVal }));
        }
    }

    const decimalValidation = (name,value) => {
        let validationArray = ['Div','TOn','LOn','LOS','TOff','ECNTRSig','ECNTRDel','ARTFactor','IB1','IB2','IBT1','IBT2'];
        if(validationArray.includes(name) && value !== '' && value?.toString()?.indexOf('.') === -1) {
            return true;
        } 
        return false;
    }


    const handleChangeAutoComplete = (value) => {
        const name  = inputRef.current?.getAttribute('name');
        const valueAddress = value?.Address ?? '';
        setModalUpdatedValues({
            name  : name,
            value : valueAddress
        })
    }

    const handleModalSubmit = () => {
        setOpen(false);
        const {name,value} = modalUpdatedValues;
        //if(value !== null &&  value !== undefined && fields[name] !== value && eventMappingData[name] !== value)  {
        if(value !== null &&  value !== undefined && showChangeBy === '1')  {
            setFields((prevState) => ({...prevState, [name]: value }));
        }
    }
    
    const handleChangeBy = (event) => {
        setShowChangeBy(event.target.value)
    }

    const changeSelectHandler = (e) => {
        const {name,value} =  e.target;
        let selectedOption;
        if(name === 'RDef'){
            selectedOption = refOptions.find(option => option.value === value);
        } else {
            selectedOption = eventTypeOptions.find(option => option.value === value);
        }
        setFields((prevState) => ({...prevState, [name]:selectedOption?.data_value}))
    }

    const handleClearAddress = (fieldName) => {
        setFields((prevUpdate) => ({...prevUpdate, [fieldName]: '' }));
    }


    const handleSubmit = () => {
        let existingEvents = JSON.parse(localStorage.getItem('Events'));
        if(existingEvents == null) existingEvents = [];
        let isExist = false;
        let removeNullKeyFields = Object.fromEntries(Object.entries(fields).filter(([_, v]) => v != null));
        if(Object.keys(removeNullKeyFields).length <= 0){
            swal("Oops!", "Please update any field", "error");
            return;
        }
        // let keysArray = [];
        // Object.keys(removeNullKeyFields).forEach(function(key) {
        //     let validationArray = ['Div','TOn','LOn','LOS','TOff','ECNTRSig','ECNTRDel','ARTFactor','IB1','IB2','IBT1','IBT2'];
        //     let keyName = {
        //         'Div' : 'Divider',
        //         'TOn': 'Time On',
        //         'LOn' : 'Level On',
        //         'LOS': 'Level On Scaler',
        //         'TOff': 'Time Off',
        //         'ECNTRSig' : 'Event Counter Reset Signal',
        //         'ECNTRDel' : 'Event Counter Reset Delay',
        //         'ARTFactor' : 'Auto Reset Time Factor',
        //         'IB1' : 'Inhibit1',
        //         'IB2' : 'Inhibit2',
        //         'IBT1' : 'Inhibit Time1',
        //         'IBT2' : 'Inhibit Time2'
        //     };
        //     if(validationArray.includes(key) && removeNullKeyFields[key] !== '' && removeNullKeyFields[key]?.toString()?.indexOf('.') === -1) {
        //         keysArray.push(keyName[key]);
        //     } 
        // });
        // if(keysArray.length > 0 ){
        //     let commaSeparatedValues = keysArray.join(', ');
        //     let message = 'Only Floating values and Addresses can be used. Try changing values for : '+commaSeparatedValues;
        //     swal("Oops!", message, "error");
        //     return false;
        // }
        if(existingEvents != null && existingEvents.length > 0){
            existingEvents =  existingEvents.map((event) =>  {
            if(event.EId === removeNullKeyFields.EId){
              isExist = true;
              return {...event,...removeNullKeyFields}
            } else {
              return event;
            }
          });
        } 
        if(!isExist){
            existingEvents.push(removeNullKeyFields);
        }
        localStorage.setItem('Events',JSON.stringify(existingEvents));
        swal({
            title: "Success",
            text: 'Event mapping updated successfully.',
            icon: "success",
        })
    }

    const getValue = (field, mappingField = field) => {
        return eventEditableKeys?.[field] != null
            ? (fields?.[field] ?? '')
            : (eventMappingData?.[mappingField] ?? '');
    };

    return (
        <>
            {showLoader && 
                <Loader />
            }
            <Breadcrumb title="Edit Mapping Event">
                <Typography component={Link} to="/" variant="subtitle2" color="primary" className="link-breadcrumb">
                    Dashboard
                </Typography>
                <Typography component={Link} to="/mapping/events" variant="subtitle2" color="primary" className="link-breadcrumb">
                    Mapping Events
                </Typography>
                <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
                Edit
                </Typography>
            </Breadcrumb>
            <Box component="section">
                <Grid className="contentBox">
                    <Grid className="modbusButtons" container direction="row" display={'flex'} justifyContent={'flex-end'}>
                        <Grid item>
                            <Button
                                component={Link} 
                                to="/mapping/events"
                                variant="contained"
                                size="small"
                                color="primary"
                                sx={{mr:3}}
                            >Back 
                            </Button>
                        </Grid>
                    </Grid>
                     <Grid container direction="row" spacing={2}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormTextField
                                width={true}
                                key="ETxt"
                                label="English Text"
                                name="ETxt"
                                value={(eventEditableKeys?.ETxt ? fields.ETxt ? fields.ETxt : '' : eventMappingData.ETxt)}
                                onBlurUpdate={changeHandler}
                                //className={eventEditableKeys?.ETxt ? 'updatedMappingField' : ''}
                                className={eventEditableKeys?.ETxt != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormTextField
                                width={true}
                                key="FTxt"
                                label="French Text"
                                name="FTxt"
                                value={(eventEditableKeys?.FTxt ? fields.FTxt ? fields.FTxt : '' : eventMappingData.FTxt)}
                                onBlurUpdate={changeHandler}
                                //className={eventEditableKeys?.FTxt ? 'updatedMappingField' : ''}
                                className={eventEditableKeys?.FTxt != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormTextField
                                width={true}
                                key="STxt"
                                label="Spanish Text"
                                name="STxt"
                                value={(eventEditableKeys?.STxt ? fields.STxt ? fields.STxt : '' : eventMappingData.STxt)}
                                onBlurUpdate={changeHandler}
                                className={eventEditableKeys?.STxt  != null  ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={2}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormTextField
                                width={true}
                                key="GTxt"
                                label="German Text"
                                name="GTxt"
                                value={(eventEditableKeys?.GTxt ? fields.GTxt ? fields.GTxt : '' : eventMappingData.GTxt)}
                                onBlurUpdate={changeHandler}
                                className={eventEditableKeys?.GTxt  != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormTextField
                                width={true}
                                key="ITxt"
                                label="Italian Text"
                                name="ITxt"
                                value={(eventEditableKeys?.ITxt ? fields.ITxt ? fields.ITxt : '' : eventMappingData.ITxt)}
                                onBlurUpdate={changeHandler}
                                className={eventEditableKeys?.ITxt  != null  ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormTextField
                                width={true}
                                key="DTxt"
                                label="Dutch Text"
                                name="DTxt"
                                value={(eventEditableKeys?.DTxt ? fields.DTxt ? fields.DTxt : '' : eventMappingData.DTxt)}
                                onBlurUpdate={changeHandler}
                                className={eventEditableKeys?.DTxt != null ?'updatedMappingField' : ''}
                             />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={2}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormTextField
                                width={true}
                                key="NTxt"
                                label="Norwegian Text"
                                name="NTxt"
                                value={(eventEditableKeys?.NTxt ? fields.NTxt ? fields.NTxt : '' : eventMappingData.NTxt)}
                                onBlurUpdate={changeHandler}
                                className={eventEditableKeys?.NTxt  != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormTextField
                                width={true}
                                key="PTxt"
                                label="Polish Text"
                                name="PTxt"
                                value={(eventEditableKeys?.PTxt ? fields.PTxt ? fields.PTxt : '' : eventMappingData.PTxt)}
                                onBlurUpdate={changeHandler}
                                className={eventEditableKeys?.PTxt != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormTextField
                                width={true}
                                key="PeTxt"
                                label="Portuguese Text"
                                name="PeTxt"
                                value={(eventEditableKeys?.PeTxt ? fields.PeTxt ? fields.PeTxt : '' : eventMappingData.PeTxt)}
                                onBlurUpdate={changeHandler}
                                className={eventEditableKeys?.PeTxt != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={2}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormTextField
                                width={true}
                                key="TTxt"
                                label="Turkish Text"
                                name="TTxt"
                                value={(eventEditableKeys?.TTxt ? fields.TTxt ? fields.TTxt : '' : eventMappingData.TTxt)}
                                onBlurUpdate={changeHandler}
                                className={eventEditableKeys?.TTxt != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormTextField
                                width={true}
                                key="CTxt"
                                label="Chinese Text"
                                name="CTxt"
                                value={(eventEditableKeys?.CTxt ? fields.CTxt ? fields.CTxt : '' : eventMappingData.CTxt)}
                                onBlurUpdate={changeHandler}
                                className={eventEditableKeys?.CTxt  != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormTextField
                                width={true}
                                key="RTxt"
                                label="Russian Text"
                                name="RTxt"
                                value={(eventEditableKeys?.RTxt ? fields.RTxt ? fields.RTxt : '' : eventMappingData.RTxt)}
                                onBlurUpdate={changeHandler}
                                className={eventEditableKeys?.RTxt != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                    </Grid> 
                    <Grid container direction="row" spacing={2}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                key="HE"
                                label="Horn Event"
                                name="HE"
                                value={eventEditableKeys?.HE != null ? (fields.HE ?? '') : eventMappingData.HE}
                                onBlurUpdate={changeHandler}
                                min={0} 
                                max={1}
                                className={eventEditableKeys?.HE != null ? 'updatedMappingField fieldFullWidth' : 'fieldFullWidth'}
                                type="int"
                             />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                key="RSA3B"
                                label="RSA3Bit"
                                name="RSA3B"
                                value={eventEditableKeys?.RSA3B != null ? (fields.RSA3B ?? '') : eventMappingData.RSA3B}
                                onBlurUpdate={changeHandler}
                                min={-1} 
                                max={39}
                                className={eventEditableKeys?.RSA3B != null ? 'updatedMappingField fieldFullWidth' : 'fieldFullWidth'}
                                type="int"
                             />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormTextField
                                width={true}
                                key="Family"
                                label="Family"
                                name="Family"
                                value={(eventEditableKeys?.Family ? fields.Family ? fields.Family : '' : eventMappingData.Family)}
                                onBlurUpdate={changeHandler}
                                className={eventEditableKeys?.Family != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                    </Grid>
                     <Grid container direction="row" spacing={2}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                key="AR"
                                label="Auto Reset"
                                name="AR"
                                value={getValue('AR')}
                                onBlurUpdate={changeHandler}
                                min={0}
                                max={1}
                                // InputProps={{
                                //     inputProps: {
                                //       type: 'number',
                                //       min: 0, max: 1,
                                //     },
                                // }}
                                className={eventEditableKeys?.AR != null ? 'updatedMappingField fieldFullWidth' : 'fieldFullWidth'}
                                type={"int"}
                             />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                key="Spn"
                                label="SPN"
                                name="Spn"
                                value={eventEditableKeys?.Spn != null ? (fields.Spn ?? '') : eventMappingData.Spn}
                                onBlurUpdate={changeHandler}
                                className={eventEditableKeys?.Spn  != null ? 'updatedMappingField fieldFullWidth' : 'fieldFullWidth'}
                                type="int"
                             />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                key="Fmi"
                                label="FMI"
                                name="Fmi"
                                value={eventEditableKeys?.Fmi != null ? (fields.Fmi ?? '') : eventMappingData.Fmi}
                                onBlurUpdate={changeHandler}
                                className={eventEditableKeys?.Fmi  != null ? 'updatedMappingField fieldFullWidth' : 'fieldFullWidth'}
                                 type="int"
                             />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={2}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                key="LOn"
                                label="Level On"
                                name="LOn"
                                value={getValue('LOn')}
                                onBlurUpdate={changeHandler}
                                min={0}
                                max={1}
                                // InputProps={{
                                //     inputProps: {
                                //       type: 'number',
                                //       min: 0, max: 1,
                                //     },
                                // }}
                                className={eventEditableKeys?.LOn  != null ? 'updatedMappingField fieldFullWidth' : 'fieldFullWidth'}
                             />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormControl
                                margin="dense"
                                fullWidth
                                className={eventEditableKeys?.RDef !== "" && fields?.RDef !== null ? 'updatedMappingField' : ''}
                            >
                                <InputLabel key="demo-simple-select-standard-label">Relation Def</InputLabel>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    key="demo-simple-select-standard"
                                    sx={{
                                        "&:focus": {
                                            backgroundColor: "#ffffff"
                                        }
                                    }}
                                    label="Relation Def"
                                    value={ eventEditableKeys?.RDef !== "" && fields?.RDef !== null ? refOptions.filter(opt => opt?.data_value === fields?.RDef).map(data => data.value) : eventMappingData?.RDef || ""}
                                    onChange={changeSelectHandler}
                                    name="RDef"
                                   
                                >
                                    <MenuItem value="">Select Relation Def</MenuItem>
                                    {refOptions?.map((option) => (
                                        <MenuItem data-value={option.data_value} key={option.value} value={option.value}>{option.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormControl
                                margin="dense"
                                fullWidth
                                className={eventEditableKeys?.EType !== "" && fields?.EType !== null ? 'updatedMappingField' : ''}
                            >
                                <InputLabel key="demo-simple-select-standard-label">Event Type</InputLabel>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    key="demo-simple-select-standard"
                                    sx={{
                                        "&:focus": {
                                            backgroundColor: "#ffffff"
                                        }
                                    }}
                                    label="Event Type"
                                    value={ eventEditableKeys?.EType !== "" && fields?.EType !== null ? eventTypeOptions.filter(opt => opt.data_value === fields?.EType).map(data => data.value) : eventMappingData?.EType || "" }
                                    onChange={changeSelectHandler}
                                    name="EType"
                                    
                                >
                                    <MenuItem value="">Select Event Type</MenuItem>
                                    {eventTypeOptions?.map((option) => (
                                        <MenuItem data-value={option.data_value} key={option.value} value={option.value}>{option.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={2}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                width={true}
                                key="TTID"
                                label="Tool Tip ID"
                                name="TTID"
                                value={eventEditableKeys?.TTID != null ? (fields.TTID ?? '') : eventMappingData.TTID}
                                onBlurUpdate={changeHandler}
                                className={eventEditableKeys?.TTID  != null ? 'updatedMappingField fieldFullWidth' : 'fieldFullWidth'}
                                type="int"
                             />
                        </Grid>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                fullWidth
                                margin="dense"
                                key="Div"
                                label="Divider"
                                name="Div"
                                //value={(eventEditableKeys?.Div || fields?.Div ? fields.Div ? fields.Div : '' : eventMappingData.Divider || "")}
                                value={(eventEditableKeys?.Div || fields?.Div || fields?.Div === 0) ? fields?.Div || fields?.Div === 0 ? fields?.Div : ''  : eventMappingData?.Divider || ""}
                                disabled={true}
                                className={eventEditableKeys?.Div  != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClickOpen('Div',((eventEditableKeys?.Div || fields?.Div || fields?.Div === 0) ? fields?.Div || fields?.Div === 0 ? fields?.Div : ''  : eventMappingData?.Divider || ""),'Divider')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('Div')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                margin="dense"
                                fullWidth
                                key="SigAddr"
                                label="Signal"
                                name="SigAddr"
                                value={(eventEditableKeys?.SigAddr || fields?.SigAddr ? fields.SigAddr ? fields.SigAddr : '' : eventMappingData.SigAddr || "")}
                                disabled={true}
                                className={eventEditableKeys?.SigAddr != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClickOpen('SigAddr',(eventEditableKeys?.SigAddr || fields?.SigAddr ? fields.SigAddr ? fields.SigAddr : '' : eventMappingData.SigAddr || ""),'Signal')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('SigAddr')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={2}>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                fullWidth
                                margin="dense"
                                key="TOn"
                                label="Time On"
                                name="TOn"
                                //value={(eventEditableKeys?.TOn || fields?.TOn ? fields.TOn ? fields.TOn : '' : eventMappingData.TOn || "")}
                                value={(eventEditableKeys?.TOn || fields?.TOn || fields?.TOn === 0) ? fields?.TOn || fields?.TOn === 0 ? fields?.TOn : ''  : eventMappingData?.TOn || ""}
                                disabled={true}
                                className={eventEditableKeys?.TOn  != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                               onClick={() => handleClickOpen('TOn',((eventEditableKeys?.TOn || fields?.TOn || fields?.TOn === 0) ? fields?.TOn || fields?.TOn === 0 ? fields?.TOn : ''  : eventMappingData?.TOn || ""),'Time On')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('TOn')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                fullWidth
                                margin="dense"
                                key="LOS"
                                label="Level On Scaler"
                                name="LOS"
                                // value={(eventEditableKeys?.LOS || fields?.LOS ? fields.LOS ? fields.LOS : '' : eventMappingData.LOS || "")}
                                value={(eventEditableKeys?.LOS || fields?.LOS || fields?.LOS === 0) ? fields?.LOS || fields?.LOS === 0 ? fields?.LOS : ''  : eventMappingData?.LOS || ""}
                                disabled={true}
                                className={eventEditableKeys?.LOS != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                               onClick={() =>handleClickOpen('LOS',((eventEditableKeys?.LOS || fields?.LOS || fields?.LOS === 0) ? fields?.LOS || fields?.LOS === 0 ? fields?.LOS : ''  : eventMappingData?.LOS || ""),'Level On Scaler')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('LOS')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                margin="dense"
                                fullWidth
                                key="TOff"
                                label="Time Off"
                                name="TOff"
                                //value={(eventEditableKeys?.TOff || fields?.TOff ? fields.TOff ? fields.TOff : '' : eventMappingData.TOff || "")}
                                value={(eventEditableKeys?.TOff || fields?.TOff || fields?.TOff === 0) ? fields?.TOff || fields?.TOff === 0 ? fields?.TOff : ''  : eventMappingData?.TOff || ""}
                                disabled={true}
                                className={eventEditableKeys?.TOff != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                               onClick={() =>handleClickOpen('TOff',((eventEditableKeys?.TOff || fields?.TOff || fields?.TOff === 0) ? fields?.TOff || fields?.TOff === 0 ? fields?.TOff : ''  : eventMappingData?.TOff || ""),'Time Off')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('TOff')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={2}>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                margin="dense"
                                fullWidth
                                key="ECNTRSig"
                                label="Event Counter Reset Signal"
                                name="ECNTRSig"
                                //value={(eventEditableKeys?.ECNTRSig || fields?.ECNTRSig ? fields.ECNTRSig ? fields.ECNTRSig : '' : eventMappingData.ECNTRSig || "")}
                                value={(eventEditableKeys?.ECNTRSig || fields?.ECNTRSig || fields?.ECNTRSig === 0) ? fields?.ECNTRSig || fields?.ECNTRSig === 0 ? fields?.ECNTRSig : ''  : eventMappingData?.ECNTRSig || ""}
                                disabled={true}
                                className={eventEditableKeys?.ECNTRSig != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                               onClick={() => handleClickOpen('ECNTRSig',((eventEditableKeys?.ECNTRSig || fields?.ECNTRSig || fields?.ECNTRSig === 0) ? fields?.ECNTRSig || fields?.ECNTRSig === 0 ? fields?.ECNTRSig : ''  : eventMappingData?.ECNTRSig || ""),'Event Counter Reset Signal')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('ECNTRSig')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                margin="dense"
                                fullWidth
                                key="ECNTRDel"
                                label="Event Counter Reset Delay"
                                name="ECNTRDel"
                                //value={(eventEditableKeys?.ECNTRDel || fields?.ECNTRDel ? fields.ECNTRDel ? fields.ECNTRDel : '' : eventMappingData.ECNTRDel || "")}
                                value={(eventEditableKeys?.ECNTRDel || fields?.ECNTRDel || fields?.ECNTRDel === 0) ? fields?.ECNTRDel || fields?.ECNTRDel === 0 ? fields?.ECNTRDel : ''  : eventMappingData?.ECNTRDel || ""}
                                disabled={true}
                                //className={eventEditableKeys?.ECNTRDel  ? 'updatedMappingField' : ''}
                                className={eventEditableKeys?.ECNTRDel != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                               onClick={() =>handleClickOpen('ECNTRDel',((eventEditableKeys?.ECNTRDel || fields?.ECNTRDel || fields?.ECNTRDel === 0) ? fields?.ECNTRDel || fields?.ECNTRDel === 0 ? fields?.ECNTRDel : ''  : eventMappingData?.ECNTRDel || ""),'Event Counter Reset Delay')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('ECNTRDel')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                margin="dense"
                                fullWidth
                                key="ARTFactor"
                                label="Auto Reset Time Factor"
                                name="ARTFactor"
                                //value={(eventEditableKeys?.ARTFactor || fields?.ARTFactor ? fields.ARTFactor ? fields.ARTFactor : '' : eventMappingData.ARTFactor || "")}
                                value={(eventEditableKeys?.ARTFactor || fields?.ARTFactor || fields?.ARTFactor === 0) ? fields?.ARTFactor || fields?.ARTFactor === 0 ? fields?.ARTFactor : ''  : eventMappingData?.ARTFactor || ""}
                                disabled={true}
                                //className={eventEditableKeys?.ARTFactor  ? 'updatedMappingField' : ''}
                                className={eventEditableKeys?.ARTFactor != null  ? 'updatedMappingField' : ''}
    
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() =>handleClickOpen('ARTFactor',((eventEditableKeys?.ARTFactor || fields?.ARTFactor || fields?.ARTFactor === 0) ? fields?.ARTFactor || fields?.ARTFactor === 0 ? fields?.ARTFactor : ''  : eventMappingData?.ARTFactor || ""),'Auto Reset Time Factor')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('ARTFactor')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={2}>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                margin="dense"
                                fullWidth
                                key="IB1"
                                label="Inhibit1"
                                name="IB1"
                                value={(eventEditableKeys?.IB1 || fields?.IB1 || fields?.IB1 === 0) ? fields?.IB1 || fields?.IB1 === 0 ? fields?.IB1 : ''  : eventMappingData?.IB1 || ""}
                                //value={(eventEditableKeys?.IB1 || fields?.IB1 ? fields.IB1 ? fields.IB1 : '' : eventMappingData.IB1 || "")}
                                disabled={true}
                                className={eventEditableKeys?.IB1 != null ? 'updatedMappingField' : ''}
                                //className={eventEditableKeys?.IB1 ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClickOpen('IB1',((eventEditableKeys?.IB1 || fields?.IB1 || fields?.IB1 === 0) ? fields?.IB1 || fields?.IB1 === 0 ? fields?.IB1 : ''  : eventMappingData?.IB1 || ""),'Inhibit1')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('IB1')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                margin="dense"
                                fullWidth
                                key="IBT1"
                                label="Inhibit Time1"
                                name="IBT1"
                                value={(eventEditableKeys?.IBT1 || fields?.IBT1 || fields?.IBT1 === 0) ? fields?.IBT1 || fields?.IBT1 === 0 ? fields?.IBT1 : ''  : eventMappingData?.IBT1 || ""}
                                //value={(eventEditableKeys?.IBT1 || fields?.IBT1 ? fields.IBT1 ? fields.IBT1 : '' : eventMappingData.IBT1 || "")}
                                disabled={true}
                                className={eventEditableKeys?.IBT1  != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                               onClick={() =>handleClickOpen('IBT1',((eventEditableKeys?.IBT1 || fields?.IBT1 || fields?.IBT1 === 0) ? fields?.IBT1 || fields?.IBT1 === 0 ? fields?.IBT1 : ''  : eventMappingData?.IBT1 || ""),'Inhibit Time1')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('IBT1')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                margin="dense"
                                fullWidth
                                key="IB2"
                                label="Inhibit2"
                                name="IB2"
                                //value={(eventEditableKeys?.IB2 || fields?.IB2 ? fields.IB2 ? fields.IB2 : '' : eventMappingData.IB2 || "")}
                                value={(eventEditableKeys?.IB2 || fields?.IB2 || fields?.IB2 === 0) ? fields?.IB2 || fields?.IB2 === 0 ? fields?.IB2 : ''  : eventMappingData?.IB2 || ""}
                                disabled={true}
                                className={eventEditableKeys?.IB2  != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                               onClick={() =>handleClickOpen('IB2',((eventEditableKeys?.IB2 || fields?.IB2 || fields?.IB2 === 0) ? fields?.IB2 || fields?.IB2 === 0 ? fields?.IB2 : ''  : eventMappingData?.IB2 || ""),'Inhibit2')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('IB2')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={2}>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                margin="dense"
                                fullWidth
                                key="IBT2"
                                label="Inhibit Time2"
                                name="IBT2"
                                // value={(eventEditableKeys?.IBT2 || fields?.IBT2 ? fields.IBT2 ? fields.IBT2 : '' : eventMappingData.IBT2 || "")}
                                value={(eventEditableKeys?.IBT2 || fields?.IBT2 || fields?.IBT2 === 0) ? fields?.IBT2 || fields?.IBT2 === 0 ? fields?.IBT2 : ''  : eventMappingData?.IBT2 || ""}
                                disabled={true}
                                className={eventEditableKeys?.IBT2  != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                               onClick={() =>handleClickOpen('IBT2',((eventEditableKeys?.IBT2 || fields?.IBT2 || fields?.IBT2 === 0) ? fields?.IBT2 || fields?.IBT2 === 0 ? fields?.IBT2 : ''  : eventMappingData?.IBT2 || ""),'Inhibit Time2')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('IBT2')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                margin="dense"
                                fullWidth
                                key="Sig0"
                                label="Log Signal0"
                                name="Sig0"
                                value={getValue('Sig0')}
                                disabled={true}
                                className={eventEditableKeys?.Sig0 != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                               onClick={() =>handleClickOpen('Sig0',(eventEditableKeys?.Sig0 || fields?.Sig0 ? fields.Sig0 ? fields.Sig0 : '' : eventMappingData.Sig0 || ""),'Log Signal0')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('Sig0')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                margin="dense"
                                fullWidth
                                key="Sig1"
                                label="Log Signal1"
                                name="Sig1"
                                value={getValue('Sig1')}
                                disabled={true}
                                className={eventEditableKeys?.Sig1 != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                               onClick={() =>handleClickOpen('Sig1',(eventEditableKeys?.Sig1 || fields?.Sig1 ? fields.Sig1 ? fields.Sig1 : '' : eventMappingData.Sig1 || ""),'Log Signal1')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('Sig1')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={2}>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                margin="dense"
                                fullWidth
                                key="Sig2"
                                label="Log Signal2"
                                name="Sig2"
                                value={getValue('Sig2')}
                                disabled={true}
                                className={eventEditableKeys?.Sig2 != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClickOpen('Sig2',(eventEditableKeys?.Sig2 || fields?.Sig2 ? fields.Sig2 ? fields.Sig2 : '' : eventMappingData.Sig2 || ""),'Log Signal2')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('Sig2')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                margin="dense"
                                fullWidth
                                key="Sig3"
                                label="Log Signal3"
                                name="Sig3"
                                value={getValue('Sig3')}
                                disabled={true}
                                className={eventEditableKeys?.Sig3 != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                               onClick={() =>handleClickOpen('Sig3',(eventEditableKeys?.Sig3 || fields?.Sig3 ? fields.Sig3 ? fields.Sig3 : '' : eventMappingData.Sig3 || ""),'Log Signal3')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('Sig3')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                margin="dense"
                                fullWidth
                                key="Sig4"
                                label="Log Signal4"
                                name="Sig4"
                                value={getValue('Sig4')}
                                disabled={true}
                                className={eventEditableKeys?.Sig4 != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                               onClick={() =>handleClickOpen('Sig4',(eventEditableKeys?.Sig4 || fields?.Sig4 ? fields.Sig4 ? fields.Sig4 : '' : eventMappingData.Sig4 || ""),'Log Signal4')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('Sig4')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={2}>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                margin="dense"
                                fullWidth
                                key="Sig5"
                                label="Log Signal5"
                                name="Sig5"
                                value={getValue('Sig5')}
                                disabled={true}
                                className={eventEditableKeys?.Sig5 != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                               onClick={() =>handleClickOpen('Sig5',(eventEditableKeys?.Sig5 || fields?.Sig5 ? fields.Sig5 ? fields.Sig5 : '' : eventMappingData.Sig5 || ""),'Log Signal5')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('Sig5')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                margin="dense"
                                fullWidth
                                key="Sig6"
                                label="Log Signal6"
                                name="Sig6"
                                value={(eventEditableKeys?.Sig6 || fields?.Sig6 ? fields.Sig6 ? fields.Sig6 : '' : eventMappingData.Sig6 || "")}
                                disabled={true}
                                className={eventEditableKeys?.Sig6  != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                               onClick={() =>handleClickOpen('Sig6',(eventEditableKeys?.Sig6 || fields?.Sig6 ? fields.Sig6 ? fields.Sig6 : '' : eventMappingData.Sig6 || ""),'Log Signal6')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('Sig6')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                margin="dense"
                                fullWidth
                                key="Sig7"
                                label="Log Signal7"
                                name="Sig7"
                                value={(eventEditableKeys?.Sig7 || fields?.Sig7 ? fields.Sig7 ? fields.Sig7 : '' : eventMappingData.Sig7 || "")}
                                disabled={true}
                                className={eventEditableKeys?.Sig7  != null ?  'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                               onClick={() =>handleClickOpen('Sig7',(eventEditableKeys?.Sig7 || fields?.Sig7 ? fields.Sig7 ? fields.Sig7 : '' : eventMappingData.Sig7 || ""),'Log Signal7')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('Sig7')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={2}>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                margin="dense"
                                fullWidth
                                key="En"
                                label="Enable"
                                name="En"
                                //value={(eventEditableKeys?.En || fields?.En ? fields.En ? fields.En : '' : eventMappingData.En || "")}
                                value={(eventEditableKeys?.En || fields?.En || fields?.En === 0) ? fields?.En || fields?.En === 0 ? fields?.En : ''  : eventMappingData?.En || ""}
                                disabled={true}
                                className={eventEditableKeys?.En  != null ? 'updatedMappingField' : ''}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClickOpen('En',(eventEditableKeys?.En || fields?.En ? fields.En ? fields.En : '' : eventMappingData.En || ""),'Enable')}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={() => handleClearAddress('En')}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                    </Grid> 
                    <Grid item xs={6} sm={4} md={3}>
                        <Grid container direction="row" spacing={1} display={'flex'} justifyContent={'flex-start'}>
                            <Grid item>
                                <Button
                                    onClick={handleSubmit}
                                    variant="contained"
                                    size="medium"
                                    color="primary"
                                    sx={{mt:2}}
                                >Submit
                                </Button>
                            </Grid>
                            <Grid item >
                                <Button
                                    component={Link} 
                                    to="/mapping/events"
                                    variant="contained"
                                    size="medium"
                                    color="error"
                                    sx={{mt:2}}
                                >Cancel
                                </Button>
                            </Grid>
                        </Grid> 
                    </Grid> 
                    <EditMappingEventModal 
                        options={options}
                        modalEditField={modalEditField}
                        open={open}
                        onClose={handleClose}
                        searchForm={searchForm}
                        sheetFilter={sheetFilter}
                        handleSheetFilter={handleSheetFilter} 
                        handleSearchValueAutoComplete={handleSearchValueAutoComplete}
                        autoCompleteOptions={sheetMappingData}
                        autoCompleteLoading={autoCompleteLoading}
                        handleBlurUpdate={changeHandler}
                        handleChangeAutoComplete={handleChangeAutoComplete}
                        inputRef={inputRef}
                        handleSubmitRowLocalStorage={handleModalSubmit}
                        handleChangeBy={handleChangeBy}
                        showChangeBy={showChangeBy}
                        searchValue={searchValue}
                    />
                </Grid>
            </Box>
        </>
    )
}

export default EditMappingEvent